module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-hover-tiny.3338a231.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-hover-tiny.png
// module id = 2640
// module chunks = 11